import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogTitle } from "@material-ui/core/";
import DialogContent from "@material-ui/core/DialogContent";
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from "react-router-dom";


// Import Pages
import AppCredentialProcess from '../appCredentialProcess/AppCredentialProcess';
import ChooseApplication from '../chooseApplication/ChooseApplication';

// Import Css
import "./AppCredentialModal.css";
import { Close } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    bottomSection: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
    },
    button: {
        border: "none",
        borderRadius: "5px",
        width: 100,
        height: 35,
        float: "right",
        "&:focus": {
            outline: "none",
        },
    },
    submit: {
        color: "white",
        marginLeft: 15,
        backgroundColor: "#079063",
        cursor: "pointer",
    }
}));

const AppCredentialModal = ({
    selectedApp,
    setSelectedApp,
    appCredentialId,
    setApplication,
    changeApp,
    setOpen,
    open,
    cancel,
    afterSave,
    isUpdateCredential,
    setIsUpdateCredential,
    data,
}) => {
    const history = useNavigate();
    const classes = useStyles();
    const { t } = useTranslation();
    const label = "CONTENT.APP-CREDENTIAL."

    return (
        <Dialog
            id="autom-addNew-modal"
            data-test="autom-add-new"
            open={true}
            onClose={() => {
                if (cancel) {
                    cancel()
                    return
                }
                setOpen(false)
            }}
            PaperProps={{
                style: {
                    minWidth: 620,
                    padding: "8px 24px 8px 24px"
                },
            }}
        >
            <DialogTitle id="alert-dialog-title">
                <div className="app-container-header-container">
                    <div id="about-title" className="head-title">
                        <div className="app-container" style={{ float: 'right', marginBottom: 0 }}>
                            <img draggable={false} className="credential-header-image" src={selectedApp.image_path} alt={selectedApp.name} />
                        </div>
                        <div className="app-credential-header">
                            <span className="new-credential-title">- {t(label + "NEW-CREDENTIAL")}</span>
                        </div>
                    </div>
                    {isUpdateCredential ? <div>
                        <Button className="switch-app-button" onClick={() => changeApp()}>{t(label + "SWITCH-APP")}</Button>
                    </div> : <Button className="close-app-select-button" data-test="cancelautom-button" onClick={() => {
                        if (cancel) {
                            cancel()
                            return
                        }
                        setOpen(false)
                    }}>
                        <Close />
                    </Button>}
                </div>
                {/* <div className="modal-header-divider"></div> */}
            </DialogTitle>
            <DialogContent>
                <AppCredentialProcess setApplication={setApplication} selectedApp={selectedApp}
                    setSelectedApp={setSelectedApp} cancel={cancel} showCancelButton={true}
                    setRefreshCredentials={afterSave} appCredentialId={appCredentialId}
                    data={data}
                />
            </DialogContent>
            {open && <ChooseApplication setApplication={setApplication} setIsUpdateCredential={setIsUpdateCredential} setOpen={setOpen} />}

        </Dialog>
    );
};

export default AppCredentialModal;
